import {isLocalePickerEnabledFromCompany} from "@/src/modules/core/lib/locale-enabled";
import {useStoredMe} from "@/src/modules/core/store/me";

export function useLocalePickerEnabled(): boolean {
  const me = useStoredMe();
  return isLocalePickerEnabledFromCompany(me?.company);
}
